/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { media } from '@atlassian/bitkit-responsive';

import ImageDiffContent from './image-diff-content';

export const TwoUp = styled.div(
  {
    display: 'flex',
  },
  media.upToLarge(`
    display: block;
  `)
);

export const ImageDiffContentCommon = styled(ImageDiffContent)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  padding: `${gridSize() * 2}px`,
  boxSizing: 'border-box',
});

export const ImageDiffContentBefore = styled(ImageDiffContentCommon)({
  background: token('color.background.danger'),
  color: token('color.text.danger'),
});

export const ImageDiffContentAfter = styled(ImageDiffContentCommon)({
  background: token('color.background.success'),
  color: token('color.text.success'),
});
